import PlatformModerationLayoutComponent from './PlatformModerationLayout.component'

export default PlatformModerationLayoutComponent